export default "__VITE_ASSET__5c995c73__"